export const SEO_TAB_VALUES = [
  "cockpit",
  "operations",
  "pages",
  "templates",
  "keywords",
  "publish",
  "scoreboard",
] as const
export type SeoTabValue = (typeof SEO_TAB_VALUES)[number]

export type SeoShortcut = readonly [keys: string, label: string]

export const SEO_TAB_LABELS: Record<SeoTabValue, string> = {
  cockpit: "Cockpit",
  operations: "Operations",
  pages: "Pages",
  templates: "Template Lab",
  keywords: "Keywords",
  publish: "Publish",
  scoreboard: "Performance",
}

export const SEO_GLOBAL_SHORTCUTS: readonly SeoShortcut[] = [
  ["Alt+1…7", "Switch SEO tab"],
  ["?", "Toggle shortcut guide"],
  ["Shift+H", "Open contextual runbook"],
]

export const SEO_CONTEXT_SHORTCUTS: Record<SeoTabValue, readonly SeoShortcut[]> = {
  cockpit: [
    ["j / ↓", "Next item, including next result set"],
    ["k / ↑", "Previous item, including prior result set"],
    ["g / G", "First / last visible item"],
    ["Enter", "Open selected item"],
    ["e / p", "Edit / preview selected page"],
    ["a", "Open selected human action"],
    ["/", "Search queue"],
    ["\\", "Reset queue"],
  ],
  operations: [],
  pages: [
    ["j / ↓", "Next page, including next result set"],
    ["k / ↑", "Previous page, including prior result set"],
    ["g / G", "First / last visible page"],
    ["Enter / p", "Preview draft"],
    ["e", "Edit selected page"],
    ["Cmd/Ctrl+S", "Save editor revision"],
    ["Esc", "Close guide or return to details"],
    ["\\", "Clear filters"],
  ],
  templates: [
    ["j / ↓", "Next template"],
    ["k / ↑", "Previous template"],
    ["1 / 2 / 3", "Desktop / tablet / mobile"],
  ],
  keywords: [
    ["/", "Search keywords"],
    ["j / ↓", "Next keyword, including next result set"],
    ["k / ↑", "Previous keyword, including prior result set"],
    ["g / G", "First / last visible keyword"],
    ["Enter / Space", "Toggle selection"],
    ["\\", "Clear filters"],
  ],
  publish: [],
  scoreboard: [],
}

export function seoShortcutsForTab(tab: SeoTabValue): readonly SeoShortcut[] {
  return [...SEO_GLOBAL_SHORTCUTS, ...SEO_CONTEXT_SHORTCUTS[tab]]
}
